export interface BlogTheme {
  primary: string;
  accent: string;
  fontFamily: string;
  logo: string;
  favicon: string;
  blogName: string;
  bloggedBy: string;
  brandText: string;
}

export const projectThemes: Record<string, BlogTheme> = {
  teamlink: {
    primary: '#2563eb', // TeamLink Blue
    accent: '#bf7039', // Tattva Copper Accent
    fontFamily: '"Inter", sans-serif',
    logo: '/apps/teamlink/logo.png',
    favicon: '/apps/teamlink/logo.png',
    blogName: 'TeamLink Blog',
    bloggedBy: 'TeamLink Team',
    brandText: 'TeamLink'
  },
  dutyvigil: {
    primary: '#5B7742', // DutyVigil Sage
    accent: '#bf7039', // Tattva Copper Accent
    fontFamily: '"Inter", sans-serif',
    logo: '/apps/dutyvigil/logo.png',
    favicon: '/apps/dutyvigil/logo.ico',
    blogName: 'DutyVigil Blog',
    bloggedBy: 'DutyVigil Engineering',
    brandText: 'DutyVigil'
  },
  tattvadynamics: {
    primary: '#bf7039', // Tattva Copper
    accent: '#ffffff',
    fontFamily: '"Inter", sans-serif',
    logo: '/logo.png',
    favicon: '/logo.ico',
    blogName: 'Tattva Blog',
    bloggedBy: 'Tattva Dynamics',
    brandText: 'Tattva Dynamics'
  },
  tictactoe: {
    primary: '#481565', // Dark Purple
    accent: '#bf7039', // Tattva Copper Accent
    fontFamily: '"Inter", sans-serif',
    logo: '/apps/tictactoe-infinite/logo.png',
    favicon: '/apps/tictactoe-infinite/logo.ico',
    blogName: 'Tic Tac Toe Blog',
    bloggedBy: 'Game Dev Team',
    brandText: 'Tic Tac Toe'
  },
  credstone: {
    primary: '#6366f1', // Indigo
    accent: '#bf7039', // Tattva Copper Accent
    fontFamily: '"Inter", sans-serif',
    logo: '/apps/credstone/logo.png',
    favicon: '/apps/credstone/logo.ico',
    blogName: 'Credstone Blog',
    bloggedBy: 'Credstone Finance',
    brandText: 'Credstone'
  }
};
